import { filesize } from 'filesize'

function humanReadableFilesize(bytes) {
  return filesize(bytes)
}

export { humanReadableFilesize }
